import PatientReports from "./PatientReports";
export default PatientReports;